const EmptyFallBackComponent = () => null;

export default EmptyFallBackComponent;
